<script>
	import { createEventDispatcher } from 'svelte'
	export let labels = [{
		text:'empty',
		color: 'gray',
	}]
	export let selected = 0
	
	const dispatch = createEventDispatcher()
	const select = item => {
		selected = labels.findIndex(x => x.text === item.text)
		dispatch('toggle', selected)
	}
	const calculatePostion = position => {
        const l = labels.length
        const lon = position + 1 === l ? true : false
        return `calc(${(100/l) * position}% ${lon ? '-' : '+'} 2px)`
    }
</script>

<div class="toggle-wrapper">
	{#each labels as a, index}
		<div class="item" on:click={() => select(a)}>
			{a.text}
		</div>
	{/each}
	{#key labels.length}
		<div class="selected" style="
			left: {calculatePostion(selected)};
			background: {labels[selected].color};
			width: calc({100/labels.length}%)
		">{labels[selected].text}</div>
	{/key}
</div>

<style>
	.toggle-wrapper {
		display: flex;
		border: 1px solid var(--white);
		width: 100%;
		height: 42px;
		align-items: center;
		justify-content: space-around;
		border-radius: 2px;
		position: relative;
        box-shadow: inset 0px 3.91101px 13.6885px rgba(255, 255, 255, 0.08);
        user-select: none;
	}
	.item {
		flex: 1;
		padding: 10px;
		cursor: pointer;
		text-align: center;
		z-index: 0;
        font-size: 1em;
        color: var(--darker);
	}
	.item:first-child {
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
	}
		.item:last-child {
		border-top-right-radius: 2px;
		border-bottom-right-radius: 2px;
	}
	.selected {
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--white);
		position: absolute;
		z-index: 1;
		transition: all 169ms ease-in-out;
		cursor: pointer;
        height: calc(100% - 4px);
        border-radius: 2px;
        font-size: 1em;
        font-weight: bold;
	}
</style>